const sentryDSN = 'https://2663d3e6ce8a86e9ac4b789a6d79af31@o4508617474965504.ingest.us.sentry.io/4508619913494528';

export default sentryDSN;
